import { isPrescriptionValue } from '../types.js';

const isParameterValueValid = (parameter, value)=>parameter.isOptional || isPrescriptionValue(value) && parameter.values.has(value)
;

export { isParameterValueValid };
//# sourceMappingURL=helpers.js.map
